import React from 'react';
export function BonusesSection() {
  const bonuses = [{
    emoji: '🎁',
    title: 'Bono 1 – Animalitos Amigurumi',
    value: 'Antes $16.500 ARS – HOY GRATIS',
    description: 'Patrones paso a paso para tejer adorables animalitos de forma fácil y divertida.'
  }, {
    emoji: '🌸',
    title: 'Bono 2 – Flores Tejidas en Crochet',
    value: 'Antes $27.900 ARS – HOY GRATIS',
    description: 'Aprende a tejer flores para decorar prendas o crear proyectos únicos.'
  }, {
    emoji: '👑',
    title: 'Bono 3 – Princesas y Personajes',
    value: 'Antes $18.900 ARS – HOY GRATIS',
    description: 'Diseños inspirados en cuentos clásicos, fáciles de seguir.'
  }, {
    emoji: '🧸',
    title: 'Bono 4 – Regalos para Nacimiento y Bautismo',
    value: 'Antes $16.900 ARS – HOY GRATIS',
    description: 'Patrones delicados para bebés y ocasiones especiales.'
  }, {
    emoji: '🎄',
    title: 'Bono 5 – Amigurumis Navideños',
    value: 'Antes $27.900 ARS – HOY GRATIS',
    description: 'Diseños temáticos para decorar o regalar en Navidad.'
  }, {
    emoji: '🗓️',
    title: 'Bono 6 – Guía para Emprender Tejiendo',
    value: 'Antes $18.900 ARS – HOY GRATIS',
    description: 'Aprende a vender tus tejidos y generar ingresos desde casa.'
  }];
  const totalValue = 16500 + 27900 + 18900 + 16900 + 27900 + 18900;
  return <section className="w-full py-16 px-4 bg-white" data-id="element-8">
      <div className="max-w-4xl mx-auto" data-id="element-9">
        <h2 className="font-heading font-bold text-3xl md:text-4xl text-center text-gray-900 mb-4" data-id="element-10">
          Bonos exclusivos
        </h2>
        <p className="font-body text-lg md:text-xl text-center text-gray-700 mb-12" data-id="element-11">
          Además del ebook con +7.000 patrones, llevate estos 6 bonos totalmente
          gratis:
        </p>

        <div className="space-y-6" data-id="element-12">
          {bonuses.map((bonus, index) => <div key={index} className="bg-gradient-to-r from-accent/10 to-accent/5 border-4 border-accent rounded-2xl p-6 md:p-8 shadow-lg" data-id="element-13">
              <div className="flex items-start gap-4" data-id="element-14">
                <div className="text-4xl md:text-5xl flex-shrink-0" data-id="element-15">
                  {bonus.emoji}
                </div>
                <div className="flex-1" data-id="element-16">
                  <h3 className="font-heading font-bold text-xl md:text-2xl text-gray-900 mb-2" data-id="element-17">
                    {bonus.title}
                  </h3>
                  <p className="font-body text-sm md:text-base text-urgency font-semibold mb-3" data-id="element-18">
                    {bonus.value}
                  </p>
                  <p className="font-body text-base md:text-lg text-gray-700" data-id="element-19">
                    {bonus.description}
                  </p>
                </div>
              </div>
            </div>)}
        </div>

        {/* Total Value Box */}
        <div className="mt-12 bg-gradient-to-br from-accent to-accent/80 rounded-3xl p-8 text-center shadow-2xl" data-id="element-20">
          <p className="font-body text-lg text-gray-800 mb-2" data-id="element-21">
            Valor total de los bonos:
          </p>
          <p className="font-heading font-bold text-4xl md:text-5xl text-gray-900 line-through mb-3" data-id="element-22">
            ${totalValue.toLocaleString('es-AR')} ARS
          </p>
          <p className="font-heading font-bold text-3xl md:text-4xl text-white bg-urgency inline-block px-8 py-3 rounded-full" data-id="element-23">
            HOY: GRATIS
          </p>
        </div>
      </div>
    </section>;
}